import { Component, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import Footerwithdr from "../../../common_components/Footerwithdr";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getVendorAuditTrackerList_action } from "../../../actions/admin_module_action/preSetupTracker_action/vendorView_action";
import {
  updateVendorPlan_action,
  getVendorPlanDetail_action,
} from "../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_plan_action";
import {
  exhibitionId,
  hallActionId,
  HallZoneActionId,
  serviceTypeId,
  stallActionId,
  toastError,
  toastSuccess,
} from "../../../utils/constants";
import moment from "moment";
import { Modal } from "react-bootstrap";
// import 'bootstrap-icons/font/bootstrap-icons.css';

const styles = {
  width: "100%",
};

class VendorPlanRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      StatusID: "",
      hallId: "",
      hallList: [],
      zoneId: "",
      zoneList: [],
      serviceId: "",
      serviceList: [],
      ExhRegNo: "",
      ExhibitorName: "",
      VendorName: "",
      ListIndex: null,
      StatusList: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      halls: [],
      grid: [],
      isVendor: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7,
      StartDate: null,
      EndDate: null,
      StartDateErr: "",
      ExhVendorPlanHdrID: null,
      isReadonly: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6 ? false : sessionStorage.getItem("vendorPlanReadonly") === "true",
      workOrderNo: sessionStorage.getItem("selectedWorkOrderNo") || "",
      serviceName: sessionStorage.getItem("selectedServiceName") || "",
      showConfirmModal: false,
      pendingAction: null,
      showStartTimeModal: false,
      pendingStartTime: null,
      pendingRowIndex: null,
      pendingHallName: null,
      showEndTimeModal: false,
      pendingEndTime: null,
    };

    this.transformVendorPlanData = this.transformVendorPlanData.bind(this);
    this.renderWorkUpdationList = this.renderWorkUpdationList.bind(this);
    this.updateVendorTime = this.updateVendorTime.bind(this);
  }

  componentDidMount() {
    this.getFillList(hallActionId, this.state.exhibitionID, "", "", "", "");
    this.getFillList(serviceTypeId, this.state.exhibitionID, "", "", "", "");

    // Get ExhVendorPlanHdrID from URL params or session storage
    const urlParams = new URLSearchParams(window.location.search);
    const ExhVendorPlanHdrID =
      urlParams.get("id") || sessionStorage.getItem("selectedVendorPlanId");

    if (ExhVendorPlanHdrID) {
      this.setState({ ExhVendorPlanHdrID });
      this.props
        .getVendorPlanDetail_action(ExhVendorPlanHdrID)
        .then((response) => {
          if (response.error === 0 && response.data?.vendorPlanDetails) {
            // Directly use the API response data
            const { halls, grid } = this.transformData(
              response.data.vendorPlanDetails
            );
            this.setState({ halls, grid });
          }
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.vendorPlanDetails !== this.props.vendorPlanDetails &&
      this.props.vendorPlanDetails.length > 0
    ) {
      this.transformVendorPlanData();
    }
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from, flag) {
    const { } = this.state;
    this.setState({ isLoading: !flag ? false : true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID === hallActionId) {
            this.setState({ hallList: data.data });
          }

          if (actionID === HallZoneActionId) {
            this.setState({ zoneList: data.data });
          }

          if (actionID === serviceTypeId) {
            this.setState({ serviceList: data.data });
          }
        }
        this.setState({ isLoading: false });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  transformVendorPlanData() {
    const vendorPlanDetails = this.props.vendorPlanDetails || [];
    console.log(
      "vendorPlanDetails in transformVendorPlanData:",
      vendorPlanDetails
    );

    if (vendorPlanDetails.length === 0) {
      this.setState({ halls: [], grid: [] });
      return;
    }

    const { halls, grid } = this.transformData(vendorPlanDetails);
    this.setState({ halls, grid });
  }

  transformData(apiData) {
    const halls = [...new Set(apiData.map((item) => item.HallName))];
    const services = [
      ...new Set(apiData.map((item) => item.DeliverablesServiceName)),
    ];

    const grid = services.map((service) => {
      const row = { service };
      halls.forEach((hall) => {
        const records = apiData.filter(
          (d) => d.DeliverablesServiceName === service && d.HallName === hall
        );
        if (records.length > 0) {
          // Use StartTime and EndTime from first record for the hall
          row[hall] = {
            StartTime: records[0].StartTime,
            EndTime: records[0].EndTime,
            vendors: records
          };
        } else {
          row[hall] = { StartTime: null, EndTime: null, vendors: [] };
        }
      });
      return row;
    });

    return { halls, grid };
  }

  handleClear() {
    this.setState(
      {
        AccountID: "",
        StatusID: "",
        hallId: "",
        zoneId: "",
        serviceId: "",
        ExhRegNo: "",
        ExhibitorName: "",
        VendorName: "",
        ExhibitionOtherAreaID: "",
        PossessionStatusID: "",
        StartDate: null,
        EndDate: null,
        StartDateErr: "",
      },
      () => this.transformVendorPlanData()
    );
  }

  navigateToVendorAndScopofwork(userId, accountId, WorkOrderID) {
    this.props.navigate("/vendorAndScopofwork", {
      state: {
        AccountID: accountId,
        UserId: userId,
        update: true,
        update: true,
        isView: false,
        replicate: false,
        WorkOrderID: WorkOrderID,
        isHallManager: sessionStorage.getItem("RoleIDSS") == 16,
        isWorkUpdation: true,
      },
    });
  }

  handleCancel = () => {
    sessionStorage.removeItem("vendorPlanReadonly");
    sessionStorage.removeItem("selectedWorkOrderNo");
    sessionStorage.removeItem("selectedServiceName");
    if (this.props.onNavigateBack) {
      this.props.onNavigateBack();
    } else if (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6) {
      this.props.navigate("/VendorPlan");
    } else {
      this.props.navigate("/VendorModule");
    }
  };

  updateVendorTime(rowIndex, hallName, field, value) {
    const { grid } = this.state;
    const updatedGrid = [...grid];
    updatedGrid[rowIndex][hallName] = {
      ...updatedGrid[rowIndex][hallName],
      [field]: value
    };
    this.setState({ grid: updatedGrid });
  }

  applyStartTimeToRow = () => {
    const { grid, pendingStartTime, pendingRowIndex, halls } = this.state;
    const updatedGrid = [...grid];
    
    halls.forEach((hall) => {
      if (updatedGrid[pendingRowIndex][hall]) {
        updatedGrid[pendingRowIndex][hall].StartTime = pendingStartTime;
      }
    });
    
    this.setState({ 
      grid: updatedGrid,
      showStartTimeModal: false,
      pendingStartTime: null,
      pendingRowIndex: null,
      pendingHallName: null
    });
  }

  cancelStartTimeModal = () => {
    this.setState({ 
      showStartTimeModal: false,
      pendingStartTime: null,
      pendingRowIndex: null,
      pendingHallName: null
    });
  }

  applyEndTimeToRow = () => {
    const { grid, pendingEndTime, pendingRowIndex, halls } = this.state;
    const updatedGrid = [...grid];
    
    halls.forEach((hall) => {
      if (updatedGrid[pendingRowIndex][hall]) {
        updatedGrid[pendingRowIndex][hall].EndTime = pendingEndTime;
      }
    });
    
    this.setState({ 
      grid: updatedGrid,
      showEndTimeModal: false,
      pendingEndTime: null,
      pendingRowIndex: null,
      pendingHallName: null
    });
  }

  cancelEndTimeModal = () => {
    this.setState({ 
      showEndTimeModal: false,
      pendingEndTime: null,
      pendingRowIndex: null,
      pendingHallName: null
    });
  }

  validateDateTime = (rowIndex, hallName, field) => {
    setTimeout(() => {
      const { grid } = this.state;
      const hallData = grid[rowIndex]?.[hallName];

      if (!hallData) return;

      const now = new Date();
      const startTime = hallData.StartTime ? new Date(hallData.StartTime) : null;
      const endTime = hallData.EndTime ? new Date(hallData.EndTime) : null;

      if (field === "StartTime" && startTime) {
        if (startTime < now) {
          toastError("Start date time cannot be less than current date time");
          this.updateVendorTime(rowIndex, hallName, "StartTime", null);
          return;
        }
      }

      if (field === "EndTime" && endTime) {
        if (startTime && endTime.getTime() === startTime.getTime()) {
          toastError("End date time cannot be same as start date time");
          this.updateVendorTime(rowIndex, hallName, "EndTime", null);
          return;
        }
      }
    }, 100);
  };

  addNewDeliverable = () => {
    const { grid, halls } = this.state;
    const newRow = { service: "", isNewService: true };

    halls.forEach((hall) => {
      // Calculate max Srno for this hall across all services
      let maxSrno = 0;
      let hallId = null;

      grid.forEach((row) => {
        if (Array.isArray(row[hall])) {
          row[hall].forEach((vendor) => {
            if (vendor.Srno > maxSrno) {
              maxSrno = vendor.Srno;
            }
            if (vendor.HallID && !hallId) {
              hallId = vendor.HallID;
            }
          });
        }
      });

      newRow[hall] = {
        StartTime: null,
        EndTime: null,
        vendors: [
          {
            ExhVendorPlanDtlID: `new_${Date.now()}_${Math.random()}`,
            Srno: maxSrno + 1,
            HallID: hallId,
            WorkOrderDeliverablesID: null,
            DeliverablesServiceName: "",
            IsCompleted: false,
            DeliverableText: "",
            isNew: true,
          },
        ]
      };
    });

    this.setState({ grid: [...grid, newRow] }, () => {
      setTimeout(() => {
        const textareas = document.querySelectorAll('.deliverable-services textarea');
        const lastTextarea = textareas[textareas.length - 1];
        if (lastTextarea) {
          lastTextarea.focus();
        }
      }, 100);
    });
  };

  updateServiceName = (rowIndex, newServiceName) => {
    const { grid } = this.state;
    const updatedGrid = [...grid];
    updatedGrid[rowIndex].service = newServiceName;

    // Update DeliverablesServiceName for all vendors in this row
    Object.keys(updatedGrid[rowIndex]).forEach((hall) => {
      if (updatedGrid[rowIndex][hall]?.vendors) {
        updatedGrid[rowIndex][hall].vendors.forEach((vendor) => {
          vendor.DeliverablesServiceName = newServiceName;
        });
      }
    });

    this.setState({ grid: updatedGrid });
  };

  handleUpdate = () => {
    this.setState({ showConfirmModal: true, pendingAction: 'submit' });
  };

  handleApprove = () => {
    this.setState({ showConfirmModal: true, pendingAction: 'approve' });
  };

  handleSaveAsDraft = () => {
    this.setState({ showConfirmModal: true, pendingAction: 'draft' });
  };

  confirmSubmit = () => {
    const { pendingAction } = this.state;
    const userRole = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;
    
    this.setState({ showConfirmModal: false });
    
    if (pendingAction === 'submit') {
      const isAdmin = userRole == 6 ? 1 : 0;
      this.submitPlan(0, 0, "Plan Submitted Successfully!", isAdmin);
    } else if (pendingAction === 'approve') {
      this.submitPlan(1, 0, "Plan Approved Successfully!", 1);
    } else if (pendingAction === 'draft') {
      const isAdmin = userRole == 6 ? 1 : 0;
      this.submitPlan(0, 1, "Plan Saved As Draft Successfully!", isAdmin);
    }
  };

  submitPlan = (IsApproved, IsSaveAsDraft, successMessage, isAdmin = 0) => {
    const { grid } = this.state;
    const planDetails = [];
    let validationError = "";

    // Extract plan details from grid and validate
    grid.forEach((row) => {
      Object.keys(row).forEach((hall) => {
        const hallData = row[hall];
        if (hallData?.vendors) {
          // Validate start and end date dependency at hall level
          if (
            (hallData.StartTime && !hallData.EndTime) ||
            (!hallData.StartTime && hallData.EndTime)
          ) {
            validationError =
              "If Start Date Time is provided, End Date Time must also be filled and vice versa.";
          }

          // Validate end date cannot be less than start date
          if (hallData.StartTime && hallData.EndTime) {
            const startDate = new Date(hallData.StartTime);
            const endDate = new Date(hallData.EndTime);
            if (endDate < startDate) {
              validationError =
                "End date and time cannot be earlier than the start date and time";
            }
          }

          hallData.vendors.forEach((vendor) => {
            planDetails.push({
              ExhVendorPlanDtlID: vendor.isNew
                ? null
                : vendor.ExhVendorPlanDtlID,
              Srno: vendor.Srno,
              HallID: vendor.HallID,
              WorkOrderDeliverablesID: vendor.WorkOrderDeliverablesID,
              DeliverablesServiceName: vendor.DeliverablesServiceName,
              StartTime: hallData.StartTime
                ? moment(hallData.StartTime)
                  .utcOffset("+05:30")
                  .format("YYYY-MM-DD HH:mm")
                : null,
              EndTime: hallData.EndTime
                ? moment(hallData.EndTime)
                  .utcOffset("+05:30")
                  .format("YYYY-MM-DD HH:mm")
                : null,
              IsCompleted: vendor.IsCompleted,
              DeliverableText: vendor.DeliverableText || "",
              isNew: vendor.isNew || false,
            });
          });
        }
      });
    });

    if (validationError) {
      toastError(validationError);
      return;
    }

    const ExhVendorHdrID =
      this.state.ExhVendorPlanHdrID ||
      this.props.vendorPlanDetails[0]?.ExhVendorPlanHdrID;
    const ExhibitionID = sessionStorage.getItem("sessionExhibitionID");

    if (!ExhVendorHdrID) {
      toastError("Service Partner Plan ID not found!");
      return;
    }

    this.setState({ isLoading: true });

    this.props
      .updateVendorPlan_action(
        ExhVendorHdrID,
        ExhibitionID,
        IsApproved,
        IsSaveAsDraft,
        planDetails,
        isAdmin
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess(successMessage);
          if (this.props.onNavigateBack) {
            this.props.onNavigateBack();
          } else {
            this.props.navigate("/vendorPlan");
          }
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  renderWorkUpdationList() {
    const { halls, grid, isReadonly } = this.state;

    return (
      <div
        className="table-freeze"
        style={{
          height: "calc(100vh - 250px)",
          overflow: "auto",
          padding: 0,
        }}
      >
        <table
          className="table table-bordered align-middle"
          style={{
            borderCollapse: "separate",
            borderSpacing: 0,
            tableLayout: "fixed",
            width: "100%",
          }}
        >
          <thead>
            <tr>
              <th
                className="text-left deliverable-services"
                style={{
                  width: "200px",
                  minWidth: "275px",
                  position: "sticky",
                  left: 0,
                  top: 0,
                  zIndex: 4,
                  backgroundColor: "#fff",
                }}
              >
                Deliverables
              </th>
              {halls.map((hall, index) => (
                <th
                  className="text-center plan-time"
                  style={{
                    width: "325px",
                    minWidth: "325px",
                    maxWidth: "325px",
                    position: "sticky",
                    top: 0,
                    zIndex: 3,
                    backgroundColor: "#fff",
                  }}
                >
                  {hall}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {grid.map((row, i) => (
              <tr key={i}>
                {/* Service column */}
                <td
                  className="text-left align-middle deliverable-services"
                  style={{ width: "200px", minWidth: "200px", position: "sticky", left: 0, zIndex: 2, backgroundColor: "#fff" }}
                >
                  {row.isNewService ? (
                    <textarea
                      className="form-control form-control-sm w-100 mt-1 w-100"
                      placeholder="Enter deliverable name"
                      value={row.service}
                      onChange={(e) =>
                        this.updateServiceName(i, e.target.value)
                      }
                      rows={3}
                      disabled={isReadonly}
                    />
                  ) : (
                    row.service
                  )}
                </td>

                {/* Hall data cells */}
                {halls.map((hall, j) => {
                  const hallData = row[hall];
                  const vendors = hallData?.vendors || [];
                  
                  // Collect all unique managers across all vendors in this hall-deliverable combination
                  const allManagers = [];
                  
                  vendors.forEach(v => {
                    const addManager = (name, email, mobile, roles) => {
                      if (!name && !email && !mobile) return;
                      
                      const existing = allManagers.find(m => 
                        m.name === name && m.email === email && m.mobile === mobile
                      );
                      
                      if (existing) {
                        roles.forEach(role => {
                          if (!existing.roles.includes(role)) {
                            existing.roles.push(role);
                          }
                        });
                      } else {
                        allManagers.push({ name, email, mobile, roles: [...roles] });
                      }
                    };

                    // Add managers with their roles
                    if (v.PreSetupManagerName || v.PreSetupManagerEmail || v.PreSetupManagerMobile) {
                      addManager(v.PreSetupManagerName, v.PreSetupManagerEmail, v.PreSetupManagerMobile, ['Pre-Setup']);
                    }
                    if (v.EventDayManagerName || v.EventDayManagerEmail || v.EventDayManagerMobile) {
                      addManager(v.EventDayManagerName, v.EventDayManagerEmail, v.EventDayManagerMobile, ['Event Days']);
                    }
                    if (v.DismantleManagerName || v.DismantleManagerEmail || v.DismantleManagerMobile) {
                      addManager(v.DismantleManagerName, v.DismantleManagerEmail, v.DismantleManagerMobile, ['Dismantling']);
                    }
                  });

                  return (
                    <td
                      className="p-1 px-2 align-top plan-time"
                      style={{
                        width: "325px",
                        minWidth: "325px",
                        maxWidth: "325px",
                      }}
                    >
                      {vendors.length === 0 && (
                        <span className="text-gray-400 fst-italic">
                          Not Allocated
                        </span>
                      )}
                      {vendors.length > 0 && (
                        <div>
                          <div className="row">
                            <div className="col-6">
                              <label className="form-label small mb-1 p-0 m-0">
                                Start Date Time
                              </label>
                              <DatePicker
                                selected={
                                  hallData.StartTime && moment(hallData.StartTime).isValid() ? moment(hallData.StartTime).toDate() : null
                                }
                                style={{ width: "325px !important" }}
                                dateFormat="dd/MM/yyyy HH:mm"
                                timeFormat="HH:mm"
                                showTimeSelect
                                timeIntervals={5}
                                className="form-control form-control-sm w-100"
                                onChange={(date) =>
                                  this.updateVendorTime(
                                    i,
                                    hall,
                                    "StartTime",
                                    date
                                  )
                                }
                                onCalendarClose={() => {
                                  if (hallData?.StartTime) {
                                    this.setState({
                                      showStartTimeModal: true,
                                      pendingStartTime: hallData.StartTime,
                                      pendingRowIndex: i,
                                      pendingHallName: hall
                                    });
                                  }
                                }}
                                onBlur={() =>
                                  this.validateDateTime(
                                    i,
                                    hall,
                                    "StartTime"
                                  )
                                }
                                minDate={new Date()}
                                minTime={new Date()}
                                maxTime={new Date().setHours(23, 59, 59, 999)}
                                filterTime={(time) => {
                                  const selectedDate = hallData.StartTime
                                    ? new Date(hallData.StartTime)
                                    : new Date();
                                  const today = new Date();
                                  if (
                                    selectedDate.toDateString() ===
                                    today.toDateString()
                                  ) {
                                    return time.getTime() >= today.getTime();
                                  }
                                  return true;
                                }}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText="Date and Time"
                                dayClassName={() =>
                                  "example-datepicker-day-class"
                                }
                                popperClassName="example-datepicker-class"
                                disabled={isReadonly}
                                popperProps={{
                                  strategy: "fixed",
                                  modifiers: [
                                    {
                                      name: "offset",
                                      options: {
                                        offset: [0, 5],
                                      },
                                    },
                                  ],
                                }}
                              />
                            </div>
                            <div className="col-6">
                              <label className="form-label small mb-1 p-0 m-0">
                                End Date Time
                              </label>
                              <DatePicker
                                selected={
                                  hallData.EndTime && moment(hallData.EndTime).isValid()
                                    ? moment(hallData.EndTime).toDate() : null
                                }
                                dateFormat="dd/MM/yyyy HH:mm"
                                timeFormat="HH:mm"
                                showTimeSelect
                                timeIntervals={5}
                                className="form-control form-control-sm w-100"
                                onChange={(date) => {
                                  if (date && hallData.StartTime && !hallData.EndTime) {
                                    const startDate = new Date(hallData.StartTime);
                                    const adjustedDate = new Date(startDate);
                                    adjustedDate.setHours(
                                      date.getHours(),
                                      date.getMinutes(),
                                      0,
                                      0
                                    );
                                    this.updateVendorTime(
                                      i,
                                      hall,
                                      "EndTime",
                                      adjustedDate
                                    );
                                  } else {
                                    this.updateVendorTime(
                                      i,
                                      hall,
                                      "EndTime",
                                      date
                                    );
                                  }
                                }}
                                onBlur={() =>
                                  this.validateDateTime(
                                    i,
                                    hall,
                                    "EndTime"
                                  )
                                }
                                onCalendarClose={() => {
                                  this.validateDateTime(
                                    i,
                                    hall,
                                    "EndTime"
                                  );
                                  if (hallData?.EndTime) {
                                    this.setState({
                                      showEndTimeModal: true,
                                      pendingEndTime: hallData.EndTime,
                                      pendingRowIndex: i,
                                      pendingHallName: hall
                                    });
                                  }
                                }}
                                minDate={
                                  hallData.StartTime ? new Date(hallData.StartTime) : null
                                }
                                minTime={(() => {
                                  if (!hallData.StartTime)
                                    return new Date().setHours(0, 0, 0, 0);
                                  const startDate = new Date(hallData.StartTime);
                                  const endDate = hallData.EndTime
                                    ? new Date(hallData.EndTime)
                                    : new Date();
                                  return startDate.toDateString() ===
                                    endDate.toDateString()
                                    ? startDate
                                    : new Date().setHours(0, 0, 0, 0);
                                })()}
                                maxTime={new Date().setHours(23, 59, 59, 999)}
                                filterTime={(time) => {
                                  if (hallData.StartTime) {
                                    const startTime = new Date(hallData.StartTime);
                                    const selectedDate = hallData.EndTime
                                      ? new Date(hallData.EndTime)
                                      : new Date(hallData.StartTime);
                                    if (
                                      selectedDate.toDateString() ===
                                      startTime.toDateString()
                                    ) {
                                      return (
                                        time.getTime() > startTime.getTime()
                                      );
                                    }
                                    return true;
                                  }
                                  return true;
                                }}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                placeholderText="Date and Time"
                                dayClassName={() =>
                                  "example-datepicker-day-class"
                                }
                                popperClassName="example-datepicker-class"
                                disabled={isReadonly}
                                popperProps={{
                                  strategy: "fixed",
                                  modifiers: [
                                    {
                                      name: "offset",
                                      options: {
                                        offset: [0, 5],
                                      },
                                    },
                                  ],
                                }}
                                style={{ zIndex: 9999 }}
                              />
                            </div>
                          </div>
                          {/* Team Members - Consolidated across all vendors */}
                          <div className="mt-2">
                            <div className="row">
                              <div className="col-12">
                                {allManagers.length > 0 ? (
                                  allManagers.map((manager, idx) => {
                                    const roleLabel = manager.roles.length === 3 ? 'All Days' : manager.roles.join(', ');
                                    return (
                                      <div key={idx} className="card mb-2 shadow-sm border rounded-3" style={{ borderColor: '#6c757d', borderWidth: '2px' }}>
                                        <span className="badge position-absolute top-0 end-0 m-1" style={{ backgroundColor: '#2e8b82', color: 'white', fontSize: '0.65rem', borderRadius: '0.3rem', padding: '0.2rem 0.4rem' }}>
                                          {roleLabel}
                                        </span>
                                        <div className="card-body p-2 d-flex align-items-center">
                                          <div className="me-2">
                                            <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: 35, height: 35 }}>
                                              <i className="ri-user-3-line fs-5" />
                                            </div>
                                          </div>
                                          <div>
                                            <h6 className="mb-0 fw-bold small">{manager.name || '-'}</h6>
                                            <p className="mb-0 text-muted small">
                                              <i className="ri-phone-line me-1" />{manager.mobile || '-'}
                                            </p>
                                            <p className="mb-0 text-muted small">
                                              <i className="ri-mail-line me-1" />{manager.email || '-'}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <div className="text-muted small p-2">-</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {
      isLoading,
      hallId,
      hallList,
      zoneId,
      zoneList,
      serviceId,
      serviceList,
      ExhibitorName,
      ExhRegNo,
      VendorName,
      RoleID,
      isVendor,
      halls,
      grid,
      isReadonly,
      workOrderNo,
      serviceName,
      showConfirmModal,
      pendingAction,
    } = this.state;
    const userRole = JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID;
    const isAdmin = userRole == 6;
    const isVendorUser = userRole == 7;

    const renderContent = () => (
      <>
        {/* <div class="row m-0">
          <div class="tab-scroll-fixed">
            <p>
              Plan & Timeline for {this.state.workOrderNo}
              {""} |{""} {this.state.serviceName}
            </p>
          </div>
        </div> */}

        <div className={`main-content ${RoleID == 7 ? "vendor-top-space": RoleID == 6 ? "dalrout-top-space" : "" }`}>
          {/* {!isReadonly && ( */}
            <div class="row m-0">
              <div
                className="d-flex justify-content-between align-items-center mt-3"
                style={{ width: "100%" }}
              >
                <h6 className="m-0">
                  Plan & Timeline for {this.state.workOrderNo} |{" "}
                  {this.state.serviceName}
                </h6>

                {userRole == 6 && (
                  <button
                    type="button"
                    className="btn btn-aqua mt-2"
                    onClick={this.addNewDeliverable}
                  >
                    Add Deliverable
                  </button>
                )}
              </div>
            </div>
          {/* )} */}
          <div className="row m-0">
            <div class="table-responsive mt-2">
              {halls.length > 0 ? (
                this.renderWorkUpdationList()
              ) : (
                <div className="p-3">Plan Loading..</div>
              )}

              <div className="mt-2 float-left">
                <div
                  className="d-flex justify-content-end gap-2 mt-0"
                  style={{ marginBottom: "10px" }}
                >
                  {!isReadonly &&
                    JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                    7 && (
                      <button
                        type="button"
                        className="btn btn-aqua"
                        onClick={this.handleSaveAsDraft}
                      >
                        Save as Draft
                      </button>
                    )}
                  {!isReadonly &&
                    JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                    7 && (
                      <button
                        type="button"
                        className="btn btn-aqua"
                        onClick={this.handleUpdate}
                      >
                        Submit
                      </button>
                    )}
                  {!isReadonly &&
                    JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                    6 && (
                      <button
                        type="button"
                        className="btn btn-aqua"
                        onClick={this.handleUpdate}
                      >
                        Update
                      </button>
                    )}
                  {!isReadonly &&
                    JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                    6 && (
                      <button
                        type="button"
                        className="btn btn-aqua"
                        onClick={this.handleApprove}
                      >
                        Approve
                      </button>
                    )}
                  <button
                    type="button"
                    className="btn btn-gray py-1"
                    onClick={this.handleCancel}
                  >
                    {isReadonly ? "Back" : "Back"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {isAdmin ? (
          <>
            <HeaderWithLogo />
            <div className="app-content with-dr-container com-height">
              {renderContent()}
            </div>
            <AdminDrawer />
            <Footerwithdr />
          </>
        ) : isVendorUser ? (
          <>
            <HeaderWithLogo />
            <div className="app-content com-height mt-0">{renderContent()}</div>
            <VendorDrawer />
            {/* <Footerwithdr /> */}
          </>
        ) : (
          renderContent()
        )}
        
        {showConfirmModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {pendingAction === 'approve' ? 'Confirm Approval' : pendingAction === 'draft' ? 'Confirm Save as Draft' : 'Confirm Submission'}
                  </h5>
                </div>
                <div className="modal-body">
                  <p>
                    {pendingAction === 'approve' 
                      ? 'Are you sure you want to approve this plan?' 
                      : pendingAction === 'draft'
                      ? 'Are you sure you want to save this plan as draft?'
                      : 'Once the plan is Approved you cannot modify it again. Are you sure you want to submit this plan?'}
                  </p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    onClick={this.confirmSubmit}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={() => this.setState({ showConfirmModal: false })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showStartTimeModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Apply Start Date Time</h5>
                </div>
                <div className="modal-body">
                  <p>Do you want to set the same start date time for all Hall?</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    onClick={this.applyStartTimeToRow}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={this.cancelStartTimeModal}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.showEndTimeModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Apply End Date Time</h5>
                </div>
                <div className="modal-body">
                  <p>Do you want to set the same end date time for all Hall?</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-aqua"
                    onClick={this.applyEndTimeToRow}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-gray"
                    onClick={this.cancelEndTimeModal}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("Redux state:", state.getVendorPlanListReducer);
  return {
    vendorPlanDetails: state.getVendorPlanListReducer?.vendorPlanDetails || [],
  };
};

export default withRouter(
  connect(mapStateToProps, {
    fill_action,
    getVendorAuditTrackerList_action,
    updateVendorPlan_action,
    getVendorPlanDetail_action,
  })(VendorPlanRecord)
);
